import { statusOf, statusColor, statusText } from "@/lib/otStatus";
import { LineChart, Line, ResponsiveContainer, YAxis, Tooltip } from "recharts";
import { Server, ShieldCheck } from "lucide-react";

export default function ScadaOverview({ tags, history }) {
  const analog = tags.filter((t) => t.type === "analog");
  const discharge = history.map((h, i) => ({ i, PT102: h["PT-102"], FT201: h["FT-201"] }));

  const nodes = [
    { name: "Engineering WS", ip: "10.10.1.20", status: "normal" },
    { name: "SCADA Server", ip: "10.10.1.10", status: "normal" },
    { name: "PLC-RTU-01", ip: "10.10.2.11", status: tags.some((t) => (t.tag_id.includes("ESD") || t.tag_id.includes("ESTOP")) && t.value === "TRIGGERED") ? "critical" : "normal" },
    { name: "HMI Panel", ip: "10.10.2.21", status: "normal" },
  ];

  return (
    <div className="space-y-4" data-testid="scada-overview">
      <div className="grid lg:grid-cols-3 gap-4">
        {/* Tag overview grid */}
        <div className="lg:col-span-2 bg-card border border-border/60 rounded-md">
          <div className="px-3 py-2 border-b border-border/60 bg-popover"><span className="label-ot">SCADA Tag Overview</span></div>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-px bg-border/40">
            {analog.map((t) => {
              const st = statusOf(t);
              return (
                <div key={t.tag_id} className="bg-card p-3" data-testid={`scada-tag-${t.tag_id}`}>
                  <div className="flex items-center justify-between">
                    <span className="font-mono text-[10px] text-muted-foreground">{t.tag_id}</span>
                    <span className="w-2 h-2 rounded-full" style={{ background: statusColor[st] }} />
                  </div>
                  <div className={`font-mono text-xl font-semibold mt-1 ${statusText[st] || ""}`}>{t.value}</div>
                  <div className="text-[10px] text-muted-foreground">{t.name} · {t.unit}</div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Network state */}
        <div className="bg-card border border-border/60 rounded-md">
          <div className="px-3 py-2 border-b border-border/60 bg-popover flex items-center gap-2">
            <Server className="w-3.5 h-3.5 text-primary" /><span className="label-ot">Network State</span>
          </div>
          <div className="p-2 space-y-1">
            {nodes.map((n) => (
              <div key={n.ip} className="flex items-center gap-2.5 px-2 py-2 rounded-sm hover:bg-secondary/30">
                <ShieldCheck className="w-4 h-4" style={{ color: statusColor[n.status] }} />
                <div className="flex-1">
                  <div className="text-xs font-medium">{n.name}</div>
                  <div className="font-mono text-[10px] text-muted-foreground">{n.ip}</div>
                </div>
                <span className="font-mono text-[10px]" style={{ color: statusColor[n.status] }}>
                  {n.status === "normal" ? "ONLINE" : "FAULT"}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Trend chart */}
      <div className="bg-card border border-border/60 rounded-md">
        <div className="px-3 py-2 border-b border-border/60 bg-popover flex items-center justify-between">
          <span className="label-ot">Live Trend · Discharge Pressure &amp; Flow</span>
          <div className="flex gap-4 font-mono text-[10px]">
            <span className="text-primary">● PT-102 (psi)</span>
            <span className="text-status-normal">● FT-201 (bbl/h)</span>
          </div>
        </div>
        <div className="p-3" style={{ height: 200 }}>
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={discharge}>
              <YAxis hide domain={["auto", "auto"]} />
              <Tooltip contentStyle={{ background: "#18181B", border: "1px solid #27272A", borderRadius: 4, fontSize: 11 }} labelStyle={{ display: "none" }} />
              <Line type="monotone" dataKey="PT102" stroke="#007AFF" strokeWidth={2} dot={false} isAnimationActive={false} />
              <Line type="monotone" dataKey="FT201" stroke="#34C759" strokeWidth={2} dot={false} isAnimationActive={false} />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
